<template>
<div v-if="token.role === 'ADM'">
  <div class="row mt-5">
    <div class="col text-center">
      <h5>Planos</h5>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col">
      <form v-on:submit.prevent="save">
        <div class="form-group">
          <label for="nome">Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="form.nome"
            id="nome"
            placeholder="Nome do plano"
          />
        </div>

        <div class="form-group">
          <label for="quantidade">Quantidade de usuários</label>
          <input
            type="text"
            class="form-control"
            v-model="form.quantidade"
            id="quantidade"
            placeholder="5"
          />
        </div>

        <div class="form-group">
          <label for="expiraDias">Expira após</label>
          <input
            type="text"
            class="form-control"
            v-model="form.expiraDias"
            id="expiraDias"
            placeholder="ex: 10 dias"
          />
        </div>

        <div class="form-group">
          <label for="valor">Valor R$</label>
          <money class="form-control" v-model="form.valor"></money>
        </div>

        <div class="form-group">
          <label for="doc">Imagem</label>
          <img
            v-if="form.filename"
            class="img-fluid img-thumbnail mb-3"
            style="max-height: 200px"
            :src="`${api}/api/v1${route}/doc/${form.filename}?token=${jwt}&mimetype=${form.mimetype}`"
          />
          <vue-dropzone ref="doc" id="doc" :options="dropzoneOptions" v-on:vdropzone-success="updateDoc"></vue-dropzone>
        </div>

        <div class="form-group mt-2">
          <button class="btn btn-primary btn-raised btn-block">Salvar</button>
          <router-link :to="route" class="btn btn-danger btn-raised btn-block">Cancelar</router-link>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import vueDropzone from 'vue2-dropzone';

export default {
  components: {
    vueDropzone
  },
  data() {
    return {
      form: {
        nome: '',
        quantidade: '',
        valor: '',
        mimetype: '',
        filename: '',
        originalname: ''
      },
      dropzoneOptions: this.$http.getDropzoneConfig(
        `/admin/planos/upload`,
        'post',
        {
          maxFiles: 1,
          addRemoveLinks: true,
          capture: true,
          dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
          dictRemoveFile: 'Remover'
        }
      ),
      route: '/admin/planos'
    };
  },
  methods: {
    save() {
      const method = this.$route.params.id ? this.$http.put : this.$http.post;

      method(this.route, this.form).then(response => {
        if (response.data.success) {
          this.$toasted.show('Cadastrado com sucesso!', this.$custom.success);
          this.$router.push(this.route);
        } else {
          this.$toasted.show('Ocorreu um erro!', this.$custom.error);
        }
      });
    },
    updateDoc(file, response) {
      this.form.mimetype = response.mimetype;
      this.form.filename = response.filename;
      this.form.originalname = response.originalname;
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$http
        .get(`${this.route}/${this.$route.params.id}`)
        .then(response => {
          if (response.data) this.form = response.data;
        });
    }
  }
};
</script>
<style>
.vue-dropzone .dz-preview .dz-details {
  background-color: #0a823b;
}
</style>



// WEBPACK FOOTER //
// src/components/app/admin/planos/Form.vue